// src/components/Footer.jsx
import React, { useEffect, useState } from "react";
import Container from "./Container.jsx";

function Accordion({ title, children, defaultOpenLg = false }) {
  const [open, setOpen] = useState(false);

  // Default open on desktop (>= lg)
  useEffect(() => {
    if (!defaultOpenLg) return;
    const mq = window.matchMedia("(min-width: 1024px)");
    const apply = () => setOpen(mq.matches);
    apply();
    mq.addEventListener?.("change", apply);
    return () => mq.removeEventListener?.("change", apply);
  }, [defaultOpenLg]);

  return (
    <div className="border-t lg:border-none border-slate-200 pt-4 lg:pt-0">
      <button
        type="button"
        className="w-full flex items-center justify-between gap-3 text-left group"
        aria-expanded={open}
        onClick={() => setOpen(o => !o)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setOpen(o => !o); }
        }}
      >
        <span className="font-semibold text-[#003366]">{title}</span>
        <svg
          className={`h-5 w-5 flex-none transition-transform duration-200 text-[#003366] ${open ? "rotate-180" : ""}`}
          viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"
        >
          <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.17l3.71-2.94a.75.75 0 111.04 1.08l-4.23 3.36a.75.75 0 01-.94 0L5.21 8.31a.75.75 0 01.02-1.1z" />
        </svg>
      </button>

      <div
        className={`grid transition-[grid-template-rows] duration-200 ease-out ${open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}
        aria-hidden={!open}
      >
        <div className="overflow-hidden">
          {children}
        </div>
      </div>
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="bg-white border-t border-slate-200">
      <Container className="py-8 lg:py-12 grid gap-6 lg:gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {/* Brand */}
        <div className="pb-2">
          <div className="flex items-center gap-2">
            <img src="content/images/ethira-logo.png" alt="Ethira" className="h-8 w-auto" />
            <span className="font-semibold text-[#003366]">Ethira Property Group</span>
          </div>
          <p className="mt-3 text-[#003366]">
            Independent UK property investment research and advisory.
          </p>
        </div>

        {/* Explore */}
        <Accordion title="Explore">
          <ul className="mt-3 space-y-2 text-[#003366]">
            <li><a href="#/news" className="hover:underline">News</a></li>
            <li><a href="#/guides" className="hover:underline">Investment Guides</a></li>
            <li><a href="#/types" className="hover:underline">Property Types</a></li>
            <li><a href="#/locations" className="hover:underline">Locations</a></li>
          </ul>
        </Accordion>

        {/* Resources */}
        <Accordion title="Resources">
          <ul className="mt-3 space-y-2 text-[#003366]">
            <li><a href="#/news" className="hover:underline">Market updates</a></li>
            <li><a href="#/guides" className="hover:underline">e-Guides</a></li>
            <li><a href="#about" className="hover:underline">About Ethira</a></li>
          </ul>
        </Accordion>

        {/* Contact */}
        <Accordion title="Contact">
          <ul className="mt-3 space-y-2 text-[#003366]">
            <li><a href="mailto:info@ethirapropertygroup.co.uk" className="hover:underline">info@ethirapropertygroup.co.uk</a></li>
            <li><a href="#/enquire" className="hover:underline">Enquire now</a></li>
          </ul>
        </Accordion>
      </Container>



<li>
  <a href="#/privacy" className="hover:underline text-[#003366]">Privacy Notice</a>
</li>
<li>
  <a href="#/privacy#cookie-policy" className="hover:underline text-[#003366]">Cookie Policy</a>
</li>

      <div className="border-t border-slate-200">
        <Container className="py-4 text-sm text-[#003366] flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <div>© {new Date().getFullYear()} Ethira Property Group. All rights reserved.</div>
          <div className="mt-2 sm:mt-0 space-x-4">
            <a href="#" className="hover:underline">Terms</a>
            <a href="#" className="hover:underline">Privacy</a>
            <a href="#" className="hover:underline">Cookies</a>
          </div>
        </Container>
      </div>
    </footer>
  );
}
